import { Tooltip } from 'react-tooltip';
import styled from 'styled-components';

import { getVariant } from '@/themes/typographyUtilis';

export const StyledTooptip = styled(Tooltip)`
  && {
    z-index: 2;
    opacity: 1;
    border-radius: 4px;
    padding: 5px 12px;
    background-color: ${({ theme }) => theme.colors.teal};
    ${getVariant({ variant: 'body2-normal' })}
  }
`;
